<div class="page-container">
  <div class="painel">
    <div>
      <div>
        <h1
          *ngIf="
            (securityService.currentUser | async)?.empresa?.nome !== 'DBMAX'
          "
          class="text-uppercase font-weight-bold mb-0"
        >
          {{ (securityService.currentUser | async)?.empresa?.nome }}
        </h1>
        <h1
          *ngIf="
            (securityService.currentUser | async)?.empresa?.nome == 'DBMAX'
          "
          class="text-uppercase font-weight-bold mb-0"
        >
          {{ (securityService.currentUser | async)?.empresa?.nome + " Direto" }}
        </h1>
      </div>
      <div>
        <div class="text-azul font-weight-bold border-bottom pt-2 pb-2">
          Olá {{ (securityService.currentUser | async)?.nome }}
          <span *ngIf="getTotalAtivacoes() > 0; else semativacoes">
            , você tem {{ getDiferencaAtivacoes("diferenca") }} de
            {{ getTotalAtivacoes() }}
            ativações hoje, até agora já realizou
            {{ getDiferencaAtivacoes("realizadas") }} (
            {{ getDiferencaAtivacoes("porcentagem") }}%)
          </span>
          <ng-template #semativacoes>
            você não tem ativações para realizar hoje
          </ng-template>
        </div>
        <div
          *ngIf="user?.empresa?.exibir_meta && user.meta"
          class="text-azul pt-2 font-weight-bold border-bottom pb-2"
        >
          Seu engajamento mensal até ontem estava em
          {{
            arredondar(
              (user.meta.qtd_clientes_ativados /
                user.meta.qtd_clientes_publicados) *
                100
            )
          }}% ({{ user.meta.qtd_clientes_ativados }} de
          {{ user.meta.qtd_clientes_publicados }}
          clientes ativados) e sua meta é de
          {{ user.meta.pct_atingimento * 100 }}% (ativar
          {{
            arredondarCima(
              user.meta.qtd_clientes_publicados * user.meta.pct_atingimento
            )
          }}
          clientes)
        </div>
      </div>
    </div>
  </div>

  <div class="ativacoes">
    <mat-list>
      <div
        style="margin-bottom: 20px"
        class="campanha-container"
        *ngFor="
          let item of (securityService.currentUser | async)?.resumoAtivacoes
            ?.campanhas
        "
      >
        <div class="campanha-box">
          <h3 style="margin-bottom: 2px" class="font-weight-bold" matLine>
            {{ item.campanha }}
          </h3>
          <p matLine style="margin-bottom: 0">
            <span class="text-azul">
              {{ item.quantidade_aberta }} contatos
            </span>
          </p>
        </div>

        <mat-icon
          *ngIf="
            securityService.canChooseCampaign && item.quantidade_aberta <= 0
          "
          style="color: gray"
          >task_alt</mat-icon
        >

        <mat-icon
          *ngIf="
            securityService.canChooseCampaign &&
            item.quantidade_aberta > 0 &&
            !ativacoesService.user?.status_bloqueio?.bloqueado
          "
          (click)="playCampaign(item)"
          [ngClass]="
            'btn-action-' +
            securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
          "
          class="play-campaign"
          >play_arrow</mat-icon
        >
      </div>
    </mat-list>
  </div>

  <div
    class="text-center alert alert-warning"
    *ngIf="ativacoesService.user?.status_bloqueio?.bloqueado; else comecar"
  >
    {{ ativacoesService.user?.status_bloqueio?.mensagem }}
  </div>
  <ng-template #comecar>
    <div
      *ngIf="getDiferencaAtivacoes('diferenca') > 0"
      class="iniciar text-center p-3"
    >
      <button
        [ngClass]="
          'btn-action-' +
          securityService.currentUserValue?.empresa?.cor_lowercase.toLowerCase()
        "
        class="btn mb-2 text-uppercase"
        [routerLink]="['/campanha']"
      >
        vamos começar
      </button>
    </div>
  </ng-template>
</div>
